import { useNuxtApp } from '#app'
import type { UseTypedI18n } from '~/types/i18n'

// Project-owned `useI18n` that replaces nuxt-i18n-micro's auto-imported one
// (stripped via the `imports:extend` hook in `nuxt.config.ts`). It returns the
// fully-typed `$i18n` injection so `t()` narrows to `string` for known keys.
export const useI18n: UseTypedI18n = () => useNuxtApp().$i18n
